// @flow

import {Tag, isMarkdocAstTag} from 'docs/util';

import type {
  MarkdocNodeRegistration,
  MarkdocTagRegistration,
} from 'docs/markdoc';

// This is for regular Markdown lists without the {% list %} tag.
export const List: MarkdocNodeRegistration = {
  node: 'list',
  component: 'List',
  children: ['item'],
  attributes: {
    ordered: {type: Boolean, required: true},
    type: {type: String},
    columns: {
      type: Number,
      default: 1,
    },
  },
};

// This supports the {% list %} tag.
export const ListTag: MarkdocTagRegistration = {
  tag: 'list',
  component: 'List',
  children: ['list', 'tag'],
  attributes: {
    type: {type: String, default: 'default'},
    columns: {type: Number, default: 1, required: false},
    className: {type: String, required: false},
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    const output = [];

    // Aggregate list items of all lists that are direct descendents of the `list` tag
    // so that list items that are wrapped with conditionals end up in the list.
    // This is necessary because block-level tags like `if` cause a list to terminate,
    // resulting in conditional list items ending up in a separate list
    for (const child of children) {
      if (isMarkdocAstTag(child) && child.name === this.tag) {
        attributes.ordered = child.attributes.ordered;
        output.push(...child.children);
      }
    }

    return new Tag(this.tag, attributes, output);
  },
};
